module.exports = __webpack_public_path__ + "static/media/website-faq1.be154ef8.png";